import keys from '@debbie/common/dist/cache/keys.js';
import { BankAccountType } from '@debbie/common/dist/index.js';
import { useMutation } from '@debbie/common/dist/util/hooks.js';
import * as creditorsAPI from '@debbie/cortex/dist/api/creditors.js';
import { creditorsEntity, useCreditor, } from '@debbie/cortex/dist/creditors/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import q from '@debbie/cortex/dist/query.js';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import THEME from '../../theme.js';
import { errorNotification } from '../../utils/errors.js';
import BankAccountInput from '../economy/BankAccountInput.js';
import { Button, SmallHeader } from '../index.js';
const BankAccountDetails = (props) => {
    const { creditorId } = props;
    const lang = useSelector((s) => s.lang);
    const creditorLoadable = useCreditor(creditorId);
    const creditor = h.hasData(creditorLoadable) ? creditorLoadable.data : null;
    const [bankAccount, setBankAccount] = useState(['', '']);
    const updateBankAccountMutation = useMutation(async () => {
        if (!creditorId) {
            return;
        }
        await creditorsAPI.update(creditorId, {
            bankAccountDetails: bankAccount[0]
                ? {
                    type: BankAccountType.Danish,
                    registrationNumber: bankAccount[0],
                    accountNumber: bankAccount[1],
                }
                : null,
        });
        q.invalidate(keys.write.modify(creditorsEntity, creditorId));
    }, {
        onError: (err) => {
            errorNotification(lang, err, 'update', lang.errorEntities.bankAccountDetails);
        },
    });
    useEffect(() => {
        if (creditor &&
            creditor.bankAccountDetails &&
            creditor.bankAccountDetails.accountNumber &&
            creditor.bankAccountDetails.registrationNumber) {
            setBankAccount([
                creditor.bankAccountDetails.registrationNumber,
                creditor.bankAccountDetails.accountNumber,
            ]);
        }
    }, [creditor]);
    return (React.createElement(React.Fragment, null,
        React.createElement(SmallHeader, null, lang.creditors.bankAccountDetails),
        React.createElement("div", { style: { display: 'flex', alignItems: 'flex-start' } },
            React.createElement(BankAccountInput, { value: bankAccount, onChange: (bankAccount) => {
                    setBankAccount(bankAccount);
                } }),
            creditor &&
                !((!bankAccount[0] &&
                    !bankAccount[1] &&
                    !creditor.bankAccountDetails) ||
                    (bankAccount[0] ==
                        creditor.bankAccountDetails?.registrationNumber &&
                        bankAccount[1] == creditor.bankAccountDetails?.accountNumber)) && (React.createElement(Button, { loading: updateBankAccountMutation.isLoading, disabled: !((!bankAccount[0] && !bankAccount[1]) ||
                    (bankAccount[0].length === 4 &&
                        bankAccount[1].length > 5 &&
                        bankAccount[1].length < 11)), onClick: () => updateBankAccountMutation.mutate(), style: { marginLeft: `${THEME.GRID_SPACING}px` } }, lang.creditors.updateBankAccountDetails)))));
};
export default BankAccountDetails;
//# sourceMappingURL=BankAccountDetails.js.map